import { Route, Routes } from 'react-router-dom';
import { RequireAuth } from '@/components/auth/RequireAuth';
import { AppShell } from '@/components/layout/AppShell';
import { LoginRoute } from '@/routes/LoginRoute';
import { DashboardRoute } from '@/routes/DashboardRoute';
import { HangfireRoute } from '@/routes/HangfireRoute';
import { CronJobsRoute } from '@/routes/CronJobsRoute';
import { StorageRoute } from '@/routes/StorageRoute';
import { ManifestRoute } from '@/routes/ManifestRoute';
import { CompletenessRoute } from '@/routes/CompletenessRoute';
import { ProviderRoute } from '@/routes/ProviderRoute';
import { EntityRoute } from '@/routes/EntityRoute';
import { NotFoundRoute } from '@/routes/NotFoundRoute';
import { PbpCoverageRoute } from '@/routes/PbpCoverageRoute';
import { PbpGameRoute } from '@/routes/PbpGameRoute';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginRoute />} />
      <Route
        path="*"
        element={
          <RequireAuth>
            <AppShell>
              <Routes>
                <Route index element={<DashboardRoute />} />
                <Route path="hangfire" element={<HangfireRoute />} />
                <Route path="jobs" element={<CronJobsRoute />} />
                <Route path="storage" element={<StorageRoute />} />
                <Route path="manifest" element={<ManifestRoute />} />
                <Route path="completeness" element={<CompletenessRoute />} />
                <Route path="pbp/presto" element={<PbpCoverageRoute />} />
                <Route path="pbp/presto/games/:eventExternalId" element={<PbpGameRoute />} />
                <Route path="entities/:providerKey" element={<ProviderRoute />} />
                <Route path="entities/:providerKey/:entityKey" element={<EntityRoute />} />
                <Route path="*" element={<NotFoundRoute />} />
              </Routes>
            </AppShell>
          </RequireAuth>
        }
      />
    </Routes>
  );
}
